import React from 'react';
import logo from './logo.svg';
import { BrowserRouter as Router, Route, Switch, Redirect,  } from 'react-router-dom';


import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero1 from './components/Hero1';
import Contacto from './components/Contacto';

import Servicios from './components/Servicios';
import Info1 from './components/Info1';
import Info2 from './components/Info2';
import Info3 from './components/Info3';
import Info4 from './components/Info4';

function App() {
  return (
    <Router>
      <Switch>
      <Route exact path='/'>
         <Header />
         <Hero1 />
         <Servicios />
         <Info1 />
         <Info4 />
         <Info3 />
         <Info2 />
         <Contacto />
         <Footer />
        </Route>
      </Switch>      
    </Router>
  );
}

export default App;
